import Icon from '../components/Icon.vue'

Icon.register({
  gem: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M485.5 0l90.5 160h-101.1l-69.2-160h79.8zM357.5 0l69.2 160h-277.4l69.2-160h139zM90.5 0h79.8l-69.2 160h-101.1zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3zM148.2 192h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0zM352.3 443.7l123-251.7h100.7l-218.7 254.9c-2.3 2.7-6.5-0.1-5-3.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/gem.js
// module id = 1378
// module chunks = 0